/**
* @function durationFormatter
* @description Format duration (total seconds) `00 hr(s) 00 min(s) 00 sec(s)`.
* @param {Number} d 
* @returns {String}
*/
export function durationFormatter(d: any) {
    let _d = Number(d);
    let hours = Math.floor(_d / 3600);
    let minutes = Math.floor((_d % 3600) / 60);
    let seconds = Math.floor(_d % 60);

    let hVal = hours > 0 ? hours + (hours === 1 ? ' hr ' : ' hrs ') : '';
    let mVal = minutes > 0 ? minutes + (minutes === 1 ? ' min ' : ' mins ') : '';
    let sVal = seconds > 0 ? seconds + (seconds === 1 ? ' sec ' : ' secs ') : '';

    if (hours === 0 && minutes === 0 && seconds === 0) {
        return '0 secs ';
    }

    return hVal + mVal + sVal;
}